// This file should replace ds/Text once we move all the docs to Goat styles.
import { typography } from '@primer-io/goat'
import styled from 'styled-components'

export const BodySmall = styled.p`
	${typography('body-small')};
`

export const BodyMedium = styled.p`
	${typography('body-medium')};
`

export const BodyLarge = styled.p`
	${typography('body-large')};
`

export const H1 = styled.h1`
	${typography('header-medium')};

	${p => p.theme.above('medium')`
		${typography('header-large')};
  `}
`

export const H2 = styled.h2`
	${typography('header-small')};

	${p => p.theme.above('medium')`
		${typography('header-medium')};
  `}
`
export const H3 = styled.h3`
	${typography('title-large')};

	${p => p.theme.above('medium')`
		${typography('header-small')};
	`}
`

export const H4 = styled.h4`
	${typography('title-medium')};

	${p => p.theme.above('medium')`
		${typography('title-large')};
	`}
`

export const H5 = styled.h5`
	${typography('title-small')};
	font-weight: 700;

	${p => p.theme.above('medium')`
		${typography('title-medium')};
	`}
`

export const H6 = styled.h6`
	${typography('label')};
`

export const Strong = styled.strong`
	font-weight: ${p => p.weight || 700};
`
